<template>
	<div class="data-table mt-50-smo mt-50-mdo">
		<slot name="head">
			<div class="data-table__header display-none-smo display-none-mdo">
				<DataTableRow>
					<DataTableCell :is-title="true" :is-header="true"> Name </DataTableCell>
					<DataTableCell :is-header="true"> 2019 </DataTableCell>
					<DataTableCell :is-header="true"> 2020 </DataTableCell>
					<DataTableCell :is-header="true"> 2021 YTD </DataTableCell>
					<DataTableCell :is-header="true"> All Time </DataTableCell>
				</DataTableRow>
			</div>
		</slot>
		<div class="data-table__body">
			<slot name="body" />
		</div>
	</div>
</template>
<script lang="ts">
export default {
	name: 'DataTable'
};
</script>
<script setup lang="ts">
import DataTableCell from '@components/account/data-table-cell.vue';
import DataTableRow from '@components/account/data-table-row.vue';
</script>
